
import { Component, Vue } from 'vue-property-decorator'
import InputItem from '~/components/common/input/InputItem.vue'
import InputText from '~/components/common/input/InputTextBasic.vue'

function isoToUnixSeconds(isoTimestamp: string) {
  const date = new Date(isoTimestamp)
  return Math.floor(date.getTime() / 1000)
}

@Component({
  name: 'DevOverrideGeneratedAt',
  components: {
    InputItem,
    InputText
  }
})
export default class DevOverrideGeneratedAt extends Vue {
  get unix() {
    return String(this.$accessor.recommendation.recommendedGeneratedAt)
  }

  set unix(value) {
    this.$accessor.recommendation.setState({
      stateName: 'recommendedGeneratedAt',
      data: value
    })
  }

  get date() {
    const { recommendedGeneratedAt } = this.$accessor.recommendation || {}
    const date = new Date(recommendedGeneratedAt * 1000)
    const isoDateString = date.toISOString().slice(0, 16)
    return isoDateString
  }

  set date(value: string) {
    this.$accessor.recommendation.setState({
      stateName: 'recommendedGeneratedAt',
      data: isoToUnixSeconds(value)
    })
  }

  get displayedNextGenerationDate() {
    const { nextGenerationDate } = this.$accessor.recommendation || {}
    return nextGenerationDate.toISOString().slice(0, 16)
  }

  set displayedNextGenerationDate(value) {
    const date = new Date(isoToUnixSeconds(value) * 1000)
    date.setDate(date.getDate() - 7)
    const unixSeconds = date.getTime() / 1000
    this.$accessor.recommendation.setState({
      stateName: 'recommendedGeneratedAt',
      data: unixSeconds
    })
  }
}
